// extracted by css-extract-rspack-plugin
export default {"staticRow":"FMeP8"};